<template>
  <Form ref="sysDictDataForm" :model="sysDictData" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate" :label-width="100" >
     <input v-model="sysDictData.id" type="hidden"/>

    <FormItem  :label="this.$t('common.sys-dict-data.dictSign.label')" prop="dictSign">
      <Input v-model="sysDictData.dictSign" :placeholder="$t('common.sys-dict-data.dictSign.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('common.sys-dict-data.dictValue.label')" prop="dictValue">
      <Input v-model="sysDictData.dictValue" :placeholder="$t('common.sys-dict-data.dictValue.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('common.sys-dict-data.dictKey.label')" prop="dictKey">
      <Input v-model="sysDictData.dictKey" :placeholder="$t('common.sys-dict-data.dictKey.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('common.sys-dict-data.styleClass.label')" prop="styleClass">
      <Input v-model="sysDictData.styleClass" :placeholder="$t('common.sys-dict-data.styleClass.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('common.sys-dict-data.isDefault.label')" prop="isDefault">
      <Select v-model="sysDictData.isDefault" :placeholder="$t('common.sys-dict-data.isDefault.holder')">
        <Option v-for="item in $t('common.sys-dict-data.isDefault.dictionary')" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
    </FormItem>

    <FormItem  :label="this.$t('common.sys-dict-data.dictSort.label')" prop="dictSort">
      <InputNumber v-model="sysDictData.dictSort" :placeholder="$t('common.sys-dict-data.dictSort.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('common.sys-dict-data.status.label')" prop="status">
      <Select v-model="sysDictData.status" :placeholder="$t('common.sys-dict-data.status.holder')">
        <Option v-for="item in $t('common.sys-dict-data.status.dictionary')" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
    </FormItem>

    <FormItem  :label="this.$t('common.sys-dict-data.remark.label')" prop="remark">
      <Input v-model="sysDictData.remark" :placeholder="$t('common.sys-dict-data.remark.holder')"  type="textarea" :rows="3"/>
    </FormItem>

  </Form>
</template>
<script>
import api from '@/api'

export default {
  data () {
    return {
      sysDictData: {
        id: null,
        dictSign: null,
        dictValue: null,
        dictKey: null,
        styleClass: null,
        isDefault: 0,
        dictSort: 0,
        status: 1,
        remark: null,
        createTime: null,
        updateTime: null,
        deleted: 0
      },
      loading: false,
      actionType:'add'
    }
  },
  methods: {
    handleSubmit(then,error){
      this.$refs['sysDictDataForm'].validate(valid => {
        if (valid) {
          if (this.sysDictData.id) {
            this.updateSysDictData(this.sysDictData).then(then).error(error)
          } else {
            this.createSysDictData(this.sysDictData).then(then).error(error)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
          error()
        }
      })
    },
    handleReset(){
      this.sysDictData.id = ''
      this.actionType = 'add';
      this.$nextTick(()=>this.$refs['sysDictDataForm'].resetFields());
    },
    getSysDictData(id,type){
      this.loading = true;
      this.$refs['sysDictDataForm'].resetFields()
      api.common.SysDictData.detail(id).then(data => {
        this.sysDictData = data;
        this.loading = false;
        this.actionType = type;
      }).catch(e => this.loading = false)
    },
    createSysDictData(sysDictData){
      this.loading = true;
      return api.common.SysDictData.add(sysDictData)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    },
    updateSysDictData(sysDictData){
      this.loading = true;
      return api.common.SysDictData.update(sysDictData)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    }
  },
  computed: {
    ruleValidate(){
      let validate =  {
      dictSign: [{type: 'string', required: true, message: this.$t('common.sys-dict-data.dictSign.required'),trigger: 'blur'}, {type: 'string',max: 100, message: this.$t('common.sys-dict-data.dictSign.max'),trigger: 'blur'}],
      dictValue: [{type: 'string', required: true, message: this.$t('common.sys-dict-data.dictValue.required'),trigger: 'blur'}, {type: 'string',max: 100, message: this.$t('common.sys-dict-data.dictValue.max'),trigger: 'blur'}],
      dictKey: [{type: 'string', required: true, message: this.$t('common.sys-dict-data.dictKey.required'),trigger: 'blur'}, {type: 'string',max: 100, message: this.$t('common.sys-dict-data.dictKey.max'),trigger: 'blur'}],
      styleClass: [{type: 'string',max: 100, message: this.$t('common.sys-dict-data.styleClass.max'),trigger: 'blur'}],
      isDefault: [{type: 'number', required: true, message: this.$t('common.sys-dict-data.isDefault.required'),trigger: 'blur'}],
      dictSort: [{type: 'number', required: true, message: this.$t('common.sys-dict-data.dictSort.required'),trigger: 'blur'}],
      status: [{type: 'number', required: true, message: this.$t('common.sys-dict-data.status.required'),trigger: 'blur'}],
      remark: [{type: 'string',max: 500, message: this.$t('common.sys-dict-data.remark.max'),trigger: 'blur'}]
      }
      if(this.actionType == 'edit'){
        this.$refs['sysDictDataForm'].fields.forEach(f => {
          if(f.$children[0].disabled){
            delete validate[f.prop]
          }
        })
      }else if(this.actionType == 'detail'){
        return {}
      }
      return validate;
    }
  }
}
</script>
